import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }
const _hoisted_6 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_7 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_8 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_12 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_13 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_14 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_15 = { class: "form-section" }
const _hoisted_16 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_17 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_18 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_19 = {
  key: 0,
  class: "mb-[2%] mt-5 text-xl font-normal"
}
const _hoisted_20 = { class: "form-section" }
const _hoisted_21 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_22 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_23 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_24 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_25 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_26 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_27 = { class: "my-[2.5%] text-2xl font-normal" }
const _hoisted_28 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_29 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}

import { ref, computed } from 'vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { Canton, Details, SchoolType } from '@/constants/offers'
    import { ExtendedContract, SelectItem, Signature } from '@/model/types'
    import FormInput from '@/components/Offers/FormInput.vue'
    import FormSelect from '@/components/Offers/FormSelect.vue'
    import formFieldsJSON from '@/components/Offers/TheProposedOfferFormFields.json'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersSearch',
  setup(__props) {

    const formFields = ref(formFieldsJSON.formFields)
    const formRef = ref(null)

    const {
        contracts,
        selectedOffer,
        proposedOffer,
        fetchOffers,
        fetchContracts,
        signaturesList,
        fetchSignaturesList,
    } = useOfferStore()

    proposedOffer.value = {}
    selectedOffer.value = {}

    async function fetchDataOnMounted() {
        await fetchSignaturesList()
        await fetchOffers()
        await fetchContracts()
    }

    fetchDataOnMounted()

    // default visibility of menus

    const showLizenzkosten = ref(true)
    const showRabattierung = ref(true)
    const showDiverses = ref(true)
    const showUnterschriften = ref(true)
    const showLanguages = ref(true)
    const language = ref(null)
    const showPDF = ref(true)

    const itemValue = (item: SelectItem) => item.key
    const itemText = (item: SelectItem) => item.value
    const itemTitle = (item: SelectItem) => item.value

    const localNumStudents = ref(selectedOffer.value?.numStudents || '')
    const localNumTeachers = ref(selectedOffer.value?.numTeachers || '')
    const localNumUserCorrection = ref(selectedOffer.value?.numUserCorrection || '')
    const localSelectedSchoolType = ref(selectedOffer.value?.schoolType || '')
    const localDetail = ref(selectedOffer.value?.detail || '')
    const localCanton = ref(selectedOffer.value?.canton || '')
    const localHasBeenSent = ref(selectedOffer.value?.hasBeenSent || false)
    const localComments = ref(selectedOffer.value?.comments || '')
    const localContract = ref(selectedOffer.value?.contract || {})
    const filteredContracts = ref<ExtendedContract[]>([])

    // custom signatures

    let signed_2 = ref<Signature>({ id: 0, name: 'Unterschrift links' })
    let signed_1 = ref<Signature>({ id: 0, name: 'Unterschrift rechts' })

    // form fields refs

    let n_relevante_nutzer = ref(proposedOffer.value?.n_relevante_nutzer || '')
    let rabatt_bisher_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_bisher?.n_nutzer_rabattzone || ''
    )
    let rabatt_bisher_stufe = ref(proposedOffer.value?.rabatt_bisher?.stufe || '')
    let rabatt_bisher_betrag = ref(proposedOffer.value?.rabatt_bisher?.betrag || '')
    let rabatt_neu_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_neu?.n_nutzer_rabattzone || ''
    )
    let rabatt_neu_stufe = ref(proposedOffer.value?.rabatt_neu?.stufe || '')
    let rabatt_neu_betrag = ref(proposedOffer.value?.rabatt_neu?.betrag || '')
    let einrichtungspreis_total = ref(proposedOffer.value?.einrichtungspreis?.total || '')
    let kosten_urg_preis_pro_nutzer = ref(proposedOffer.value?.kosten_urg?.preis_pro_nutzer || '')
    let kosten_urg_total = ref(proposedOffer.value?.kosten_urg?.total || '')
    let sockelbetrag_preis_pro_nutzer = ref(
        proposedOffer.value?.sockelbetrag?.preis_pro_nutzer || ''
    )
    let sockelbetrag_total = ref(proposedOffer.value?.sockelbetrag?.total || '')
    let introduction = ref(proposedOffer.value?.introduction || '')
    let scope = ref(proposedOffer.value?.scope || '')
    let closure = ref(proposedOffer.value?.closure || '')

    const computedProperty = (propPath: string) => {
        if (typeof propPath !== 'string') {
            return computed(() => '')
        }

        const pathParts = propPath.split('.')
        return computed({
            get: () => {
                let currentValue = proposedOffer.value
                for (const part of pathParts) {
                    if (currentValue === null || currentValue === undefined) {
                        return ''
                    }
                    currentValue = currentValue[part]
                }
                return currentValue
            },
            set: (newValue) => {
                let currentValue = proposedOffer.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    if (currentValue && currentValue[part] === undefined) {
                        currentValue[part] = {}
                    }
                    if (currentValue !== null && currentValue !== undefined) {
                        currentValue = currentValue[part]
                    }
                }
                if (currentValue !== null && currentValue !== undefined) {
                    currentValue[pathParts[pathParts.length - 1]] = newValue
                }
            },
        })
    }

    rabatt_bisher_n_nutzer_rabattzone = computedProperty('rabatt_bisher.n_nutzer_rabattzone')
    rabatt_bisher_stufe = computedProperty('rabatt_bisher.stufe')
    rabatt_bisher_betrag = computedProperty('rabatt_bisher.betrag')
    rabatt_neu_n_nutzer_rabattzone = computedProperty('rabatt_neu.n_nutzer_rabattzone')
    rabatt_neu_stufe = computedProperty('rabatt_neu.stufe')
    rabatt_neu_betrag = computedProperty('rabatt_neu.betrag')
    einrichtungspreis_total = computedProperty('einrichtungspreis.total')
    kosten_urg_preis_pro_nutzer = computedProperty('kosten_urg.preis_pro_nutzer')
    kosten_urg_total = computedProperty('kosten_urg.total')
    sockelbetrag_preis_pro_nutzer = computedProperty('sockelbetrag.preis_pro_nutzer')
    sockelbetrag_total = computedProperty('sockelbetrag.total')

    const updateProposedOfferValue = (propPath: string, newValue: any) => {
        if (typeof propPath !== 'string') {
            return
        }

        const pathParts = propPath.split('.')
        let currentValue = proposedOffer.value
        for (let i = 0; i < pathParts.length - 1; i++) {
            const part = pathParts[i]
            if (!currentValue || !currentValue[part]) {
                if (currentValue && currentValue[part] === undefined) {
                    currentValue[part] = {}
                }
            }
            if (currentValue !== null && currentValue !== undefined) {
                currentValue = currentValue[part]
            }
        }
        if (currentValue !== null && currentValue !== undefined) {
            currentValue[pathParts[pathParts.length - 1]] = newValue
        }
    }

    // functions defined and used here

    function filterContracts() {
        if (!contracts.value || !Array.isArray(contracts.value)) {
            console.error('Contracts data is not available')
            return
        }

        filteredContracts.value = contracts.value.filter((contract) => {
            return contract.Typ === localDetail.value && contract[localCanton.value]
        })
    }

    function onChangeSchoolType() {
        localDetail.value = ''
        localCanton.value = ''
        filteredContracts.value = []
    }

    function search() {
        console.log("I don't work yet")
    }

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[45] || (_cache[45] = _createElementVNode("h2", { class: "text-left text-2xl mb-[3%] font-medium" }, "Offerte Suchen", -1)),
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers(search, ["prevent"]),
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                _createVNode(FormInput, {
                  modelValue: localNumStudents.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localNumStudents).value = $event)),
                  label: "#SuS / Studierende",
                  required: "",
                  onChange: _cache[1] || (_cache[1] = (e) => (localNumStudents.value = e.target.value))
                }, null, 8, ["modelValue"]),
                _createVNode(FormInput, {
                  modelValue: localNumTeachers.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localNumTeachers).value = $event)),
                  label: "#LuL / Dozierende",
                  required: "",
                  onChange: _cache[3] || (_cache[3] = (e) => (localNumTeachers.value = e.target.value))
                }, null, 8, ["modelValue"]),
                _createVNode(FormInput, {
                  modelValue: localNumUserCorrection.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localNumUserCorrection).value = $event)),
                  label: "Korrektur # relevanter Nutzer",
                  onChange: _cache[5] || (_cache[5] = (e) => (localNumUserCorrection.value = e.target.value))
                }, null, 8, ["modelValue"]),
                _createVNode(FormSelect, {
                  modelValue: localSelectedSchoolType.value,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((localSelectedSchoolType).value = $event)),
                    onChangeSchoolType
                  ],
                  items: _unref(SchoolType),
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  label: "Schultyp",
                  required: "",
                  onChange: _cache[7] || (_cache[7] = (e) => (localSelectedSchoolType.value = e.target.value))
                }, null, 8, ["modelValue", "items"]),
                _createVNode(FormSelect, {
                  modelValue: localDetail.value,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((localDetail).value = $event)),
                    filterContracts
                  ],
                  items: localSelectedSchoolType.value ? _unref(Details)[localSelectedSchoolType.value] : [],
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  label: "Details",
                  required: "",
                  onChange: _cache[9] || (_cache[9] = (e) => (localDetail.value = e.target.value))
                }, null, 8, ["modelValue", "items"]),
                _createVNode(FormSelect, {
                  modelValue: localCanton.value,
                  "onUpdate:modelValue": [
                    _cache[10] || (_cache[10] = ($event: any) => ((localCanton).value = $event)),
                    filterContracts
                  ],
                  items: _unref(Canton),
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  label: "Kanton",
                  required: "",
                  onChange: _cache[11] || (_cache[11] = (e) => (localCanton.value = e.target.value))
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_v_textarea, {
                  modelValue: localComments.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((localComments).value = $event)),
                  label: "Kommentar"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_radio_group, {
                  class: "w-fit",
                  modelValue: localContract.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((localContract).value = $event)),
                  row: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContracts.value, (contract) => {
                      return (_openBlock(), _createBlock(_component_v_radio, {
                        key: contract?.UUID,
                        label: String(contract?.LeadPortal_Name),
                        value: contract
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: localHasBeenSent.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((localHasBeenSent).value = $event)),
                  color: "#db0720",
                  label: "Versand Angebot erfolgt"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _cache[39] || (_cache[39] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_6, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (showLizenzkosten.value = !showLizenzkosten.value))
              }, [
                _cache[33] || (_cache[33] = _createTextVNode("Lizenzkosten ", -1)),
                (showLizenzkosten.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (_openBlock(), _createElementBlock("i", _hoisted_8))
              ])
            ]),
            (showLizenzkosten.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 0,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(FormInput, {
                      modelValue: _unref(n_relevante_nutzer),
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(n_relevante_nutzer) ? (n_relevante_nutzer).value = $event : n_relevante_nutzer = $event)),
                      label: "Anzahl relevante Nutzer",
                      onChange: _cache[17] || (_cache[17] = (e) => (_isRef(n_relevante_nutzer) //@ts-ignore
 ? n_relevante_nutzer.value = e.target.value : n_relevante_nutzer = e.target.value))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[0], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field?.disabled || false,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[40] || (_cache[40] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_11, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (showRabattierung.value = !showRabattierung.value))
              }, [
                _cache[34] || (_cache[34] = _createTextVNode("Rabattierung ", -1)),
                (showRabattierung.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                  : (_openBlock(), _createElementBlock("i", _hoisted_13))
              ])
            ]),
            (showRabattierung.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 1,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[1], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_14, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field.disabled || false,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_16, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (showDiverses.value = !showDiverses.value))
              }, [
                _cache[35] || (_cache[35] = _createTextVNode("Diverses ", -1)),
                (showDiverses.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                  : (_openBlock(), _createElementBlock("i", _hoisted_18))
              ])
            ]),
            (showDiverses.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 2,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value[2], (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        ('title' in section)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_19, _toDisplayString(section.title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field) => {
                            return (_openBlock(), _createBlock(FormInput, {
                              key: field.label,
                              label: field.label,
                              modelValue: computedProperty(field.model).value as string,
                              "onUpdate:modelValue": ($event: any) => ((computedProperty(field.model).value as string) = $event),
                              disabled: field.disabled,
                              onChange: 
                                    (event) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                          }), 128))
                        ])
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[42] || (_cache[42] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_21, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (showUnterschriften.value = !showUnterschriften.value))
              }, [
                _cache[36] || (_cache[36] = _createTextVNode("Unterschriften ", -1)),
                (showUnterschriften.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                  : (_openBlock(), _createElementBlock("i", _hoisted_23))
              ])
            ]),
            (showUnterschriften.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 3,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      style: {"width":"50%","display":"inline-block"},
                      class: "p-[5px]",
                      modelValue: _unref(signed_2),
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(signed_2) ? (signed_2).value = $event : signed_2 = $event)),
                      items: _unref(signaturesList),
                      "item-title": "name",
                      "item-value": "id",
                      "return-object": "",
                      "single-line": ""
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_select, {
                      style: {"width":"50%","display":"inline-block"},
                      class: "p-[5px]",
                      modelValue: _unref(signed_1),
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(signed_1) ? (signed_1).value = $event : signed_1 = $event)),
                      items: _unref(signaturesList),
                      "item-title": "name",
                      "item-value": "id",
                      "return-object": "",
                      "single-line": ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[43] || (_cache[43] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_24, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (showLanguages.value = !showLanguages.value))
              }, [
                _cache[37] || (_cache[37] = _createTextVNode("Sprache ", -1)),
                (showLanguages.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                  : (_openBlock(), _createElementBlock("i", _hoisted_26))
              ])
            ]),
            (showLanguages.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 4,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: language.value,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((language).value = $event)),
                      inline: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Deutsch",
                          value: "DE"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Französisch",
                          value: "FR"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Italienisch",
                          value: "IT"
                        }),
                        _createVNode(_component_v_radio, {
                          class: "w-25",
                          label: "Englisch",
                          value: "EN"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[44] || (_cache[44] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("h2", _hoisted_27, [
              _createElementVNode("span", {
                class: "cursor-pointer",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (showPDF.value = !showPDF.value))
              }, [
                _cache[38] || (_cache[38] = _createTextVNode("PDF bearbeiten ", -1)),
                (showPDF.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                  : (_openBlock(), _createElementBlock("i", _hoisted_29))
              ])
            ]),
            (showPDF.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 5,
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individuelle Einleitung",
                      modelValue: _unref(introduction),
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(introduction) ? (introduction).value = $event : introduction = $event)),
                      onChange: _cache[27] || (_cache[27] = (e) => (_isRef(introduction) //@ts-ignore
 ? introduction.value = e.target.value : introduction = e.target.value))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individueller Leistungsumfang",
                      modelValue: _unref(scope),
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(scope) ? (scope).value = $event : scope = $event)),
                      onChange: _cache[29] || (_cache[29] = (e) => (_isRef(scope) //@ts-ignore
 ? scope.value = e.target.value : scope = e.target.value))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      style: {"width":"100%","display":"inline-block"},
                      class: "p-[5px]",
                      label: "Individueller Schluss",
                      modelValue: _unref(closure),
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_isRef(closure) ? (closure).value = $event : closure = $event)),
                      onChange: _cache[31] || (_cache[31] = (e) => (_isRef(closure) //@ts-ignore
 ? closure.value = e.target.value : closure = e.target.value))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(FullButton, {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (search())),
              width: "100",
              title: "Suchen",
              colour: "white"
            })
          ]),
          _: 1
        }, 512)
      ])
    ])
  ], 64))
}
}

})